<template>
<div class="animated fadeIn">
  <v-client-table :data="floors" :columns="columns" :options="options" :theme="theme">
    <template slot="child_row" slot-scope="data">
      <room-search :rooms="data.row.rooms" @selected="selectRoom"></room-search>
    </template>
  </v-client-table>
</div>
</template>

<script>
import Vue from 'vue'
import {
  mapState,
} from 'vuex'
import RoomSearch from './RoomSearch'

export default {
  name: "FloorSearch",
  props: {
    floors: Array
  },
  components: {
    RoomSearch
  },
  data() {
    return {
      columns: [
        'floor_number',
        'rooms.length',
      ],
      options: {
        headings: {
          'floor_number': 'Floor Number',
          'rooms.length': 'Available Rooms',
        },
        sortable: [],
        filterable: [],
        sortIcon: {
          base: 'fa',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
          is: 'fa-sort'
        },
        pagination: {
          chunk: 5,
          edge: true,
          nav: 'scroll'
        },
        perPage: 25,
      },
      theme: 'bootstrap4',
    }
  },
  methods: {
    selectRoom(room) {
      this.$emit('selected', room)
    }
  },
}
</script>
